<!-- @format -->
<div>
	<!-- Search -->
	<section class="hmf-pr-s">
		<product-reviews-search-input
			class="search-input"
			placeholder="Search Reviews"></product-reviews-search-input>
	</section>

	<!-- Filters Selection -->
	@if (reviewsFilters) {
		<section
			class="filters-container hmf-display-flex hmf-mt-l hmf-pl-xxxs hmf-pl-lg-0"
			[ngClass]="{
				'horizontal-scroll': isMobile(),
				'horizontal-scroll--clip': isMobile() && isDropdownOpen,
				'hmf-flex-row hmf-flex-wrap': !isMobile()
			}">
			<product-reviews-dropdown-select
				class="select-filter--sort"
				ariaLabel="reviews-select-sort"
				[disabled]="hasSearched"
				[dropdownList]="sortOptions"
				[isMobile]="isMobile()"
				[label]="labelSort"
				[trigger]="triggerSortDefault"
				(dropdownEvent)="handleDropdownEvent($event)"
				(handleUpdatedList)="updateSortOptions($event)"
				(handleIndividualCheckedList)="getSelectedSortOption($event)"
				[reviewsFilters]="reviewsFilters"
				(wasDefault)="handleWasSortDefault($event)">
			</product-reviews-dropdown-select>
			<product-reviews-dropdown-select
				class="select-filter--rating"
				ariaLabel="reviews-select-rating"
				label="Rating"
				[closeOnSelection]="false"
				[isMultipleChoice]="true"
				[dropdownList]="ratingOptions"
				[isMobile]="isMobile()"
				[trigger]="trigger"
				(handleIndividualCheckedList)="getSelectedRatingOption($event)"
				(handleUpdatedList)="updatedRatingOptions($event)"
				(dropdownEvent)="handleDropdownEvent($event)"
				[reviewsFilters]="reviewsFilters"
				(wasDefault)="handleWasDefault($event)">
			</product-reviews-dropdown-select>
			<product-reviews-toggle-select
				ariaLabel="reviews-with-mages-or-videos"
				[content]="labelImageReviews"
				[filterName]="filterTypes.HAS_MEDIA"
				[isMobile]="isMobile()"
				[selected]="isMediaSelected"
				(toggleEvent)="handleToggleSelector($event)">
			</product-reviews-toggle-select>
			<product-reviews-toggle-select
				ariaLabel="verified-purchases"
				[content]="labelVerifiedPurchases"
				[filterName]="filterTypes.VERIFIED_PURCHASER"
				[isMobile]="isMobile()"
				[selected]="isVerifiedPurchaserSelected"
				(toggleEvent)="handleToggleSelector($event)">
			</product-reviews-toggle-select>
		</section>
	}
	<!-- Filter Chips -->
	@if ((reviewsFilters || reviewsProsCons) && filters.length) {
		<section class="hmf-mt-s review-filters">
			<product-reviews-filter-chips
				class="filters-chips hmf-display-flex hmf-flex-wrap"
				[isHighlyRatedReviewsEnabled]="isHighlyRatedReviewsEnabled"
				(clearFilter)="handleClearFilter($event)"
				(clearAllFilters)="handleClearAllFilters()">
			</product-reviews-filter-chips>
		</section>
	}

	@if (reviewsFilters && reviewCount === 0) {
		<section class="hmf-mt-xs no-results-found">
			<p
				id="no-results-found"
				class="hmf-body-bold-m hmf-m-0">
				Sorry, no reviews matches the applied filters.
			</p>
		</section>
	}
</div>
